import { getCalendarEventDisplayName } from '../../calendarDisplayUtils'
import CalendarEventHoverTooltip from '../../CalendarEventHoverTooltip'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const LargeMonthViewEventChip = ({event, setEditEvent, setEventToEdit}) => {
    const displayName = getCalendarEventDisplayName(event.name)

    const openEvent = (e) => {
        setEditEvent(true)
        setEventToEdit(e)
      }

    return (
      <CalendarEventHoverTooltip event={event}>
        <li key={event.id} className="calendar__month-event-item">
            <div id="existing-event" onClick={() => openEvent(event)} className={`calendar__month-event group ${event.isIntro ? 'bg-amber-100' : event.color.bgColor200}`}>
                <div id="existing-event" className={`w-1 h-3 mt-1 rounded-sm ${event.color.bgColor500}`}></div>
                <time id="existing-event" dateTime={event.datetime} className="hidden flex-none ml-1 font-thin text-gray-900 mt-0.5 xl:block text-xs">{event.time}</time>
                <p id="existing-event" className={classNames( event.isIntro ? 'text-green-700 font-extrabold' : `${event.color.textColor800}` ,"flex-auto truncate font-bold my-0 ml-2 w-1 py-0.5 text-left text-xs")}>{displayName}</p>
            </div>
        </li>
      </CalendarEventHoverTooltip>
    )
}
export default LargeMonthViewEventChip
